// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2evxw","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__gLNGD"};